module.exports = __webpack_public_path__ + "img/icon-empty-cart.a2705136.png";